import axios from 'axios';

const api = axios.create({
  // URL relativa: nginx roteia /api para o backend correto em cada domínio
  // (porta 8003 para Lagoa Azul, porta 8004 para Neto Lanches, etc.)
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = String(error.config?.url || '');
    const requisicaoDeLogin = url.endsWith('/auth/login') || url === 'auth/login';
    if (error.response?.status === 401 && !requisicaoDeLogin) {
      localStorage.removeItem('usuario');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
